// extracted by mini-css-extract-plugin
export default {"site-tag-plus":"N5efS"};